import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import { connect } from 'react-redux';
import TranslateNew from '@translate/TranslateNew';
import { ChatStyle } from './Chat.style';
import { CHAT_TYPE, IChatMessage, IChatReaction, IMessageReadInfo } from '@app-types/websocket/chat.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import ChatReactionBar from './ChatReactionBar';
import { getOS } from '@helpers/osDetection';
import CordovaContext from '../../cordovaContext';
import ChatActionBar from './ChatActionBar';
import PinchZoomImage from '@helpers/PinchZoomImage';
import { Link } from 'react-router-dom';
import {articleTargetForLink} from '@containers/knowledge/articleNavigation';
import ArticleLink from '@components/common/ArticleLink';
import { styleColors } from 'src/main.style';
import { SaveAlt } from '@material-ui/icons';
import { replyPreviewText } from '@services/chat/chatReply';


const tn: TranslateNew = TranslateNew.getInstance();
const urlAndEmailRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|\/app[^\s]+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
const internalLinkRegex = /^(?:https?:\/\/(?:varannanvecka\.app|co-parenting\.app))?(\/app[^\s]*)/i;
const os = getOS();
const EMPTY_FAMILY:IFamilyMember[] = [];

interface IProps extends WithStyles<typeof ChatStyle> {
  chatId:number;
  userId:number;
  sender:IFamilyMember|undefined;
  enhancedVisibility:boolean;
  family:IFamilyMember[];
  messageReadInfo?:IMessageReadInfo;
  
  chatMessage : IChatMessage;
  chatReactions : IChatReaction[]|undefined;
  replyToMessage?: IChatMessage; // the message this one replies to, when it is loaded
  reactTo : ()  => void;
  reply?: () => void; // starts a reply to this message; left out where that isn't possible
  clearReaction : () => void;
  haltMessage : (msg:IChatMessage, rewrite:"ORIGINAL"|"AISUGGESTION"|"EMPTY") => void;
  sendMessage : (msg:IChatMessage) => void;
  addReaction : boolean;

  firstMessage:boolean;
  lastMessage:boolean;

  inTransit?:boolean;
  toxic?:number;

  sendReaction: (reaction: string) => void;
}

class ChatMessage extends React.Component<IProps> {
  private timeoutId: NodeJS.Timeout | null = null;
  private longPressThreshold: number = 500; // milliseconds
  private moveThreshold: number = 10; // pixels

  private doubleTapPreviousTime: number = 0;

  private longPressActivated: boolean = false;
  private touchStartX: number = 0;
  private touchStartY: number = 0;

  constructor(props: IProps) {
    super(props);
  }

  public componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  public render() {

    const {classes, userId, chatMessage, firstMessage, lastMessage, sender, addReaction, enhancedVisibility} = this.props;
    let name:JSX.Element|undefined 
    let avatar:JSX.Element|undefined 
    let image:JSX.Element|undefined 
    let time:JSX.Element|undefined 
    let reaction:JSX.Element|undefined 
    let replyQuote:JSX.Element|undefined;
    let videoDownloadButton:JSX.Element|undefined;
    let attachmentURL:string|undefined;
    const messageTextStyle = enhancedVisibility ? {fontSize: '19px'} : undefined;
    const messageText = typeof chatMessage.msg === "string" ? chatMessage.msg : "";
    const readInfo = addReaction ? this.formatReadInfo() : '';
    const showReadInfo = readInfo !== '';
    const timeClass = classes.chatTime + (showReadInfo ? ' ' + classes.chatTimeWithReadInfo : '');
    const rowClass = classes.chatMessage + (showReadInfo ? ' ' + classes.chatMessageWithReadInfo : '');

    let msgStyle:string = classes.chatMessageMsg;
    if (lastMessage && chatMessage.senderId === userId) {
      msgStyle = msgStyle+" "+classes.chatMessageMsgLastRight;
    } else if (lastMessage && chatMessage.senderId !== userId) {
      msgStyle = msgStyle+" "+classes.chatMessageMsgLastLeft;
    } 

    if (addReaction) {
      msgStyle = msgStyle+" "+classes.chatMessageMsgReaction;
    }

    if (this.props.inTransit && this.props.chatMessage.rewrite !== undefined && this.props.chatMessage.rewrite.length > 0) {
      msgStyle = msgStyle+" "+classes.chatMessageBadAlternative;
    }

    if (firstMessage || lastMessage) {
      if (firstMessage) {
        let senderName = tn.lang.unknown;
        if (sender) {
          senderName = sender.firstName;
        } else if (chatMessage.senderId === 0) {
          if (chatMessage.chatType && chatMessage.chatType === CHAT_TYPE.SYSTEM_CHAT) {
            senderName = tn.lang.support;
          } else {
            senderName = tn.lang.varannanVecka;
          }
        }
        name = <div style={chatMessage.senderId === userId?{right:'8px'}:{left:'8px'}} 
          className={classes.chatMessageSender}>{senderName}</div>
      }
      if (lastMessage) {
        if (sender) {
          avatar = <ImgAvatar imgName={sender.avatar} color={sender.color} border={true} style={{width: 28,height: 28, borderWidth:'2px'}}
            imgUrl={sender.imageAvatar ? sender.avatarURL : undefined} />;
        } else if (chatMessage.senderId === 0) {
          avatar = <div className={classes.chatIconAvatar} >
            <img src={"vv.png"} className={classes.imageIcon} style={{borderRadius: '100px', border: '0.5px solid #ccc', boxSizing: 'border-box'}}/>
          </div>;
        } else {
          avatar = <div className={classes.chatIconAvatar} />;
        }
        time = <div className={timeClass} style={chatMessage.senderId === userId?{right:'4px'}:{left:'4px'}}>
            {tn.formatTime(new Date(chatMessage.sendingTime))}{readInfo}
          </div>
      }
    }

    if (this.props.addReaction) {
      time = <div className={timeClass} style={chatMessage.senderId === userId?{right:'4px',
        color:styleColors.greyMedium2}:{left:'4px', color:styleColors.greyMedium2}}>
            {tn.formatTime(new Date(chatMessage.sendingTime))}{readInfo}
          </div>
    }

    if (this.props.chatReactions !== undefined && this.props.chatReactions.length > 0) {
      reaction = <div className={timeClass} style={chatMessage.senderId !== userId
        ?{left:'4px',fontSize: '16px'}:{right:'4px', fontSize: '16px'}}>
        {this.props.chatReactions.map(rea=>rea.msg).join("")}
      </div>
    }

    if (chatMessage.questionId !== undefined && chatMessage.questionId > 0) {
      const preview = replyPreviewText(this.props.replyToMessage);
      replyQuote = <div className={classes.chatReplyQuote}>
        <span className={classes.chatReplyLabel}>{tn.lang.chatReplyTo}</span>
        <span className={classes.chatReplyText}>{preview !== '' ? preview : tn.lang.chatReplyToEarlierMessage}</span>
      </div>;
    }

    if (chatMessage.fileDesc && chatMessage.fileDesc.url && chatMessage.fileDesc.fileName) {
      attachmentURL = chatMessage.fileDesc.url ;
      const fileName = typeof chatMessage.fileDesc.fileName === "string" ? chatMessage.fileDesc.fileName : "";
      const imageUrlRegex: RegExp = /\.(jpeg|jpg|gif|png|webp|svg|bmp|jiff|tiff|ico)(\?.*)?$/i;
      const isImage = imageUrlRegex.test(fileName);
      if (isImage) {
        if (this.props.addReaction) {   
          image = <PinchZoomImage src={chatMessage.fileDesc.url} style={{height: "auto"}}/>;
          // image = <img src={chatMessage.fileDesc.url} className={classes.chatImage} onClick={() => this.props.reactTo()} />
        } else {
          image = <img src={chatMessage.fileDesc.url} className={classes.chatImage} onClick={() => this.props.reactTo()} />
        }
      } else {
        const videoUrlRegex: RegExp = /\.(mp4|avi|mov|mkv|webm|flv|wmv|mpeg|mpg|3gp|ogg|ogv)(\?.*)?$/i;
        if (videoUrlRegex.test(fileName)) {
          videoDownloadButton = <a
            href={chatMessage.fileDesc.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${classes.chatLink} ${classes.chatMessageDownloadLink}`}
            title={tn.lang.download}
            aria-label={tn.lang.download}
          >
            <SaveAlt />
          </a>;
          image = <video controls={true}
            onClick={(evt) => this.handleVideoClick(evt)}
            // ref={videoRef}
            src={chatMessage.fileDesc.url}
            className="video-element"
            preload="metadata"
          />
        } else {
          image = <a href={chatMessage.fileDesc.url} target="_blank" rel="noopener noreferrer">{fileName}</a>
        }
      }
      
      // image = <div style={{backgroundImage:"url("+chatMessage.fileDesc.url+")"}}/>
    }

    if (userId === chatMessage.senderId) {
      return (
        <div id={`chat-message-${chatMessage.id}`} className={rowClass} style={this.props.addReaction?{zIndex:3, marginTop:(firstMessage?'12px':0)}
          :{marginTop:(firstMessage?'12px':0)}}>
          <div className={classes.chatMessageSpace}  onClick={() => {this.props.clearReaction()}}/>
          <div className={msgStyle} 
            onClick={() => this.props.reactTo()}
            // onTouchStart={this.handleTouchStart}
            // onTouchMove={this.handleTouchMove}
            // onTouchEnd={(e) => this.handleTouchEnd(e)}
          >
            {name}
            {replyQuote}
            {image}
            <div style={{display:'block', opacity: this.props.inTransit && !addReaction?0.3:1, overflow:'auto',
              maxHeight:((addReaction)?'200px':'unset'), ...messageTextStyle}} >
              {this.renderMessageWithLinks(messageText)}
            </div>
            {!showReadInfo && time}
            {!showReadInfo && reaction}
          </div>
          
          <div className={classes.chatMessageIcon}>
            {videoDownloadButton}
            {avatar}
          </div>
          {addReaction && <ChatActionBar edit={() => this.handleEdit(chatMessage)} isOnline={true} status={chatMessage.status} 
            rewrite={chatMessage.rewrite} attachmentURL={attachmentURL}
            hasText={messageText !== ""}
            toxicVerdict={chatMessage.toxicVerdict}
            cancel={() => this.props.haltMessage(chatMessage, "EMPTY")}
            send={() => this.handleSend(chatMessage)} isSent={!(this.props.inTransit === true)}
            copy={() => this.handleCopy(chatMessage)} reply={this.props.reply} fromMe={true} sendingTime={chatMessage.sendingTime} />}
          {showReadInfo && <div className={classes.chatReadInfo} style={{textAlign:'right'}} onClick={() => this.props.reactTo()}>
            {time}{reaction && <React.Fragment> {reaction}</React.Fragment>}
          </div>}
        </div>

      );  
    } else {
      return (
        <div id={`chat-message-${chatMessage.id}`} className={rowClass} style={this.props.addReaction?{zIndex:3, marginTop:(firstMessage?'12px':0)}
          :{marginTop:(firstMessage?'12px':0)}}>
          {addReaction 
            && <ChatReactionBar send={(data) => this.props.sendReaction(data)}/>}
          <div className={classes.chatMessageIcon}>
            {videoDownloadButton}
            {avatar}
          </div>
          <div className={msgStyle} 
            onClick={() => this.props.reactTo()}
            // onTouchStart={this.handleTouchStart}
            // onTouchMove={this.handleTouchMove}
            // onTouchEnd={(e) => this.handleTouchEnd(e)}
          >
            {name}
            {replyQuote}
            {image}
            <div style={{display:'block', whiteSpace: 'normal', ...messageTextStyle}} >
              {this.renderMessageWithLinks(messageText)}
            </div>
            {!showReadInfo && time}
            {!showReadInfo && reaction}
          </div>
          {addReaction && <ChatActionBar edit={() => this.props.clearReaction()} isOnline={true}
            hasText={messageText !== ""} cancel={() => {return;}} attachmentURL={attachmentURL}
            send={() => this.props.clearReaction()} isSent={true}
            copy={() => this.handleCopy(chatMessage)} reply={this.props.reply} fromMe={false} sendingTime={chatMessage.sendingTime} />}
          <div className={classes.chatMessageSpace} onClick={() => {this.props.clearReaction()}}/>
          {showReadInfo && <div className={classes.chatReadInfo} style={{textAlign:'left'}} onClick={() => this.props.reactTo()}>
            {time}{reaction && <React.Fragment> {reaction}</React.Fragment>}
          </div>}
        </div>
      );
  
    }

  }

  private formatReadInfo():string {
    const {messageReadInfo, chatId, chatMessage, family, inTransit, userId} = this.props;
    if (inTransit || !messageReadInfo || messageReadInfo.chatId !== chatId
      || messageReadInfo.msgId !== chatMessage.id) {
      return '';
    }

    const readers:string[] = [];
    for (const accountId of Object.keys(messageReadInfo.participants)) {
      const receipt = messageReadInfo.participants[accountId];
      if (!receipt || Number(accountId) === userId || Number(accountId) === chatMessage.senderId
        || (receipt.status !== 'READ' && receipt.status !== 'READ_TIME_UNKNOWN')) {
        continue;
      }
      const member = family.find((person) => person.id === Number(accountId));
      const name = member ? member.firstName : tn.lang.unknown;
      const readDate = receipt.status === 'READ' && typeof receipt.readTime === 'number'
        && receipt.readTime > 0 ? new Date(receipt.readTime) : undefined;
      const date = readDate && Number.isFinite(readDate.getTime())
        ? `${readDate.getDate()} ${tn.lang.getMonthNameShort(readDate.getMonth())}` : '';
      readers.push(date ? `${name}: ${date}` : name);
    }
    return readers.length > 0 ? ` (${tn.lang.chatReadBy(readers.join('; '))})` : '';
  }

  private handleCopy = (chatMessage:IChatMessage) => {
    const messageText = typeof chatMessage.msg === "string" ? chatMessage.msg : "";

    // navigator.clipboard is missing on WebViews without a secure context.
    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      navigator.clipboard.writeText(messageText)
      .then(() => {
        console.log('Message copied to clipboard');
      })
      .catch(err => {
        if (!this.legacyCopyToClipboard(messageText)) {
          alert('Failed to copy text to clipboard');
        }
      });
    } else if (!this.legacyCopyToClipboard(messageText)) {
      alert('Failed to copy text to clipboard');
    }

    this.props.clearReaction();
  }

  private legacyCopyToClipboard = (text:string):boolean => {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(textarea);
      return copied;
    } catch (error) {
      return false;
    }
  }

  private handleEdit = (chatMessage:IChatMessage) => {
    this.props.haltMessage(chatMessage, "ORIGINAL");
  }

  private handleSend = (chatMessage:IChatMessage) => {
    this.props.sendMessage(chatMessage);
  }

  private handleVideoClick = (event: React.MouseEvent<HTMLVideoElement, MouseEvent>) => {
    const video = event.currentTarget;

    if (video.paused) {
      video.play().catch((err) => {
        console.warn("Video play failed:", err);
      });
    } else {
      video.pause();
    }
  };

  private isGifUrl = (url: string): boolean => {
    return /\.(gif)(\?.*)?$/.test(url) || url.includes("giphy.com/media");
  };

  private isImageUrl = (url: string): boolean => {
    return /\.(png|jpe?g|gif|webp|bmp|svg|avif)(\?.*)?$/i.test(url);
  };

  private renderMessageWithLinks = (text: string = "") => {
    const parts = text.split(urlAndEmailRegex);

    return parts.map((part, index) => {
      urlAndEmailRegex.lastIndex = 0;
      if (urlAndEmailRegex.test(part)) {
        urlAndEmailRegex.lastIndex = 0;
        
      const articleTarget = articleTargetForLink(part);
      if (articleTarget) {
        return <ArticleLink key={index} article={articleTarget} className={this.props.classes.chatLink}>{tn.lang.here}</ArticleLink>;
      }
      // check if its an internal app link
      const match = part.match(internalLinkRegex);
      if (match) {
        const locallink = match[1];           // always starts with '/app'
        return (
          <Link key={index} to={locallink} className={this.props.classes.chatLink}>
            {tn.lang.here}
          </Link>
        );
      }

        // Check if it's an animated GIF
        if (this.isGifUrl(part)) {
          return (
            <img
              key={index}
              src={part}
              alt="GIF"
              style={{
                width:'auto',
                maxWidth: "240px",
                maxHeight: "240px",
              }}
              onClick={() => this.props.reactTo()}
            />
          );
        } else if (this.isImageUrl(part)) {
          return (
            <img
              key={index}
              src={part}
              alt="Image"
              style={{
                width:'auto',
                maxWidth: "240px",
                maxHeight: "240px",
              }}
              onClick={() => this.props.reactTo()}
            />
          );
        }

        // Check if it's an email
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(part)) {
          return (
            <a key={index} className={this.props.classes.chatLink} href={`mailto:${part}`} target="_blank" rel="noopener noreferrer">
              {part}
            </a>
          );
        }

        // Otherwise, it's a URL
        const hasProtocol = part.startsWith('http');
        const href = hasProtocol ? part : `http://${part}`; // Ensure links starting with 'www' are clickable

        return (
          <a key={index} href={href} className={this.props.classes.chatLink} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return <span key={index} style={{whiteSpace: 'pre-wrap', userSelect:'none', WebkitUserSelect:'none'}}>{part}</span>;
    });
  };
}
  

ChatMessage.contextType = CordovaContext;

function mapStateToProps(state: any, props:{chatId:number, chatMessage:IChatMessage}) {
  return {
    enhancedVisibility: state.user.enhancedVisibility === true,
    family: state.family && Array.isArray(state.family.family) ? state.family.family : EMPTY_FAMILY,
    messageReadInfo: state.chat && state.chat.messageReadInfo
      && state.chat.messageReadInfo[props.chatId]
      ? state.chat.messageReadInfo[props.chatId][props.chatMessage.id] : undefined,
  };
}

export default connect(mapStateToProps)(withStyles(ChatStyle)(ChatMessage));



// WEBPACK FOOTER //
// ./src/components/chat/ChatMessage.tsx